import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
  return (
    <div className="error404-page">
      <h1>Error 404</h1>
      <Link to="/">Go back to the dashboard</Link>
    </div>
  );
};

export default Error404;
